import classNames from "classnames"
import { ControlStateOptions } from "components/DesignSystemUtils/ControlStateOptions"
import { determineLineControlBoxClass } from "components/DesignSystemUtils/determineLineControlBoxClass"

/**
 * @deprecated Use ControlStateOptions instead
 */
interface Props {
  error?: boolean
  success?: boolean
  disabled?: boolean
}

/**
 * @deprecated Use determine* functions from frontend/src/components/DesignSystemUtils
 */
export const containerClasses = ({ error, success }: Props) =>
  classNames(
    "flex flex-col text-body2/regular justify-center",
    { "text-red-500": error },
    { "text-green-500": success }
  )

/**
 * @deprecated Use determine* functions from frontend/src/components/DesignSystemUtils
 */
export const inputClasses = (state: ControlStateOptions = {}) => determineLineControlBoxClass(state)
